import { useEffect, type RefObject } from 'react';

// Takes focus for a prompt that appears unbidden, and hands it back on the way out —
// answering one must not cost the SDR their place.
//
// The restore is conditional because two prompts can be up at once: without the check,
// the first to unmount yanks focus off whatever the second had legitimately taken.
export function useFocusOnMount(
  target: RefObject<HTMLElement | null>,
  root: RefObject<HTMLElement | null>,
): void {
  useEffect(() => {
    const previous = document.activeElement;
    target.current?.focus();
    return () => {
      if (!root.current?.contains(document.activeElement)) return;
      if (previous instanceof HTMLElement) previous.focus();
    };
  }, [target, root]);
}
